/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MoveUserRequestCto } from '../../models/move-user-request-cto';
import { UserUpdateContextCto } from '../../models/user-update-context-cto';

export interface MoveUserToCompany$Plain$Params {
  userId: string;
      body?: MoveUserRequestCto
}

export function moveUserToCompany$Plain(http: HttpClient, rootUrl: string, params: MoveUserToCompany$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserUpdateContextCto>> {
  const rb = new RequestBuilder(rootUrl, moveUserToCompany$Plain.PATH, 'put');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserUpdateContextCto>;
    })
  );
}

moveUserToCompany$Plain.PATH = '/user/{userId}/moveToCompany';
